import { Injectable } from '@angular/core';
import { PaginatedAbstractService } from './paginated.abstract.service';
import {
  UserRepository,
  UserRepositoryParams
} from '../repositories/user.repository';
import { Store } from '@ngrx/store';
import { getCurrentTenantSettings } from '../../core/states/tenant-state/tenant.selectors';
import { firstValueFrom, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends PaginatedAbstractService<UserRepositoryParams> {
  $defaultOrigin$: Observable<'my_settlement' | 'all'> = this.store
    .select(getCurrentTenantSettings)
    .pipe(
      map(settings =>
        settings.filter_by_location_by_default ? 'my_settlement' : 'all'
      )
    );

  constructor(
    userRepository: UserRepository,
    private store: Store
  ) {
    super(userRepository);
  }

  override async fetch(params?: UserRepositoryParams['queryParams']) {
    // Only fall back to the tenant-default origin when the caller hasn't set
    // one. Previously this always clobbered the explicit value, so toggling
    // "All" / "My location" in the filter modal had no effect on results.
    const origin =
      params?.origin ?? (await firstValueFrom(this.$defaultOrigin$));
    super.fetch({
      ...params,
      origin
    });
  }
}
